import React from 'react';
import { CaptionText, HeadingText } from '@paypalcorp/pp-react-text';
import { V2CausesIcon } from '@paypalcorp/pp-react-icons';
import PropTypes from 'prop-types';
import getContent from 'pp-react-l10n';

const GNCSubheader = ({ organizationName, purpose }) => {
  return (
    <div className="donate_sub_header donate-main-content">
      <div className="gnc-subheader">
        <HeadingText className="charity-header" level={2}>
          {purpose}
        </HeadingText>
        <div className="charity-subtitle">
          <V2CausesIcon size="sm" className="subtitle-icon" />
          <CaptionText>
            {getContent('locals')('common/subHeader')(
              'label.supportingOrganization',
              { organization: organizationName }
            )}
          </CaptionText>
        </div>
      </div>
    </div>
  );
};

GNCSubheader.propTypes = {
  organizationName: PropTypes.string,
  purpose: PropTypes.string,
};

export default GNCSubheader;
